export const GET_PRODUCTION_ITEM_MODE_2 = 'GET_PRODUCTION_ITEM_MODE_2'
export const GET_PRODUCTION_ITEM_MODE_2_SUCCESS = 'GET_PRODUCTION_ITEM_MODE_2_SUCCESS'

export const GET_PRODUCTION_LIST_PAGE = 'GET_PRODUCTION_LIST_PAGE'
export const GET_PRODUCTION_LIST_PAGE_SUCCESS = 'GET_PRODUCTION_LIST_PAGE_SUCCESS'

export const POST_PRODUCTION_FROM_PRODUCTION_PAGE = 'POST_PRODUCTION_FROM_PRODUCTION_PAGE'
export const POST_PRODUCTION_FROM_PRODUCTION_PAGE_SUCCESS = 'POST_PRODUCTION_FROM_PRODUCTION_PAGE_SUCCESS'

export const EDIT_PRODUCTION_FOR_PRODUCTION_PAGE = 'EDIT_PRODUCTION_FOR_PRODUCTION_PAGE'
export const EDIT_PRODUCTION_FOR_PRODUCTION_PAGE_SUCCESS = 'EDIT_PRODUCTION_FOR_PRODUCTION_PAGE_SUCCESS'

export const UPDATE_PRODUCTION_ID_FROM_PRODUCTION_PAGE = 'UPDATE_PRODUCTION_ID_FROM_PRODUCTION_PAGE'
export const UPDATE_PRODUCTION_ID_FROM_PRODUCTION_PAGE_SUCCESS = 'UPDATE_PRODUCTION_ID_FROM_PRODUCTION_PAGE_SUCCESS'

export const DELETE_PRODUCTION_ID = 'DELETE_PRODUCTION_ID'
export const DELETE_PRODUCTION_SUCCESS = 'DELETE_PRODUCTION_SUCCESS'

export const GO_BUTTON_FOR_PRODUCTION_PAGE = 'GO_BUTTON_FOR_PRODUCTION_PAGE'
export const GO_BUTTON_FOR_PRODUCTION_PAGE_SUCCESS = 'GO_BUTTON_FOR_PRODUCTION_PAGE_SUCCESS'

export const GET_UNIT_ID_FOR_PRODUNCTION = 'GET_UNIT_ID_FOR_PRODUNCTION'
export const GET_UNIT_ID_FOR_PRODUNCTION_SUCCESS = 'GET_UNIT_ID_FOR_PRODUNCTION_SUCCESS'

export const PRODUNCTION_API_ERROR_ACTION = "PRODUNCTION_API_ERROR_ACTION"

export const MATERIAL_REISSUE_PRODUCTION_ID="MATERIAL_REISSUE_PRODUCTION_ID"
export const MATERIAL_REISSUE_PRODUCTION_ID_SUCCESS="MATERIAL_REISSUE_PRODUCTION_ID_SUCCESS"






